import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReportsCustom4Route: InvariantJiraRoute = {
	name: 'csm-reports-custom',
	path: '/jira/customer-service-management/projects/:projectKey/reports/custom/:reportId',
};
